//import {BrowserCacheLocation, Configuration, LogLevel, PublicClientApplication} from "@azure/msal-browser";
import * as msal from "@azure/msal-browser";
import { handleCallback } from "../../utils";

interface Props {
    clientId: string,
}

const msalInstance = ({ clientId }: Props) => {
    const msalConfig: msal.Configuration = {
	    auth: {
		    clientId: clientId,
    		authority: "https://globalempd.b2clogin.com/globalempd.onmicrosoft.com/B2C_1_EMPD",
//	    	authority: `https://login.microsoftonline.com/b1c38ebf-20ad-4e13-83aa-c05466194035`,
		    knownAuthorities: ["globalempd.b2clogin.com"],
    		redirectUri: `/auth_callback`,
	    	postLogoutRedirectUri: `${window.location.origin}`,
			navigateToLoginRequestUrl: false,
    	},
	    cache: {
		    cacheLocation: msal.BrowserCacheLocation.LocalStorage,
    		storeAuthStateInCookie: false,
	    	secureCookies: false
    	}
    };

	const instance = new msal.PublicClientApplication(msalConfig);
//	handleCallback(instance)
	return instance
}

export default msalInstance;
